import React from 'react';


import Rating from '@material-ui/lab/Rating';

import './styles.css';

export default function SkillCard(props) {
    return(
        <div className="skillcard-container">
            <div className="skillcard-content">
                <header>
                    <span className="icon">
                        { props.content.icon }
                    </span>
                    <h2>
                        { props.content.title }
                    </h2>
                </header>
                <main>
                    <p>
                        { props.content.text }
                    </p>
                </main>
                <footer>
                    <span className="skillcard-level">
                        <span>
                            Nível
                        </span>
                        <Rating 
                            name="half-rating" 
                            defaultValue={ props.content.level } 
                            size="large" 
                            readOnly
                        />
                    </span>
                </footer>
            </div>
         </div>
    );
}